import type { ContractSchema } from '@libs/data-access/entities'
import type { QueryFnParams } from '@libs/data-access/queries'
import { httpServices } from '@libs/data-access/queries'

export type FetchContractOptions = QueryFnParams<{
  pathParams: {
    user_contract_id: number
  }
  queryParams: {
    includes?: string[]
  }
}>

export const fetchContractById = async (opts: FetchContractOptions) => {
  const response = await httpServices.core.get<ContractSchema>(
    `/user_contracts/${opts.pathParams.user_contract_id}`,
    { params: opts?.queryParams }
  )

  return response.data
}

export type FetchContractsOptions = QueryFnParams<{
  queryParams: {
    team_ids?: number[]
  }
}>

export const fetchContracts = async (opts: FetchContractsOptions) => {
  const response = await httpServices.core.get<ContractSchema[]>(
    `/accounts/${httpServices.authInfo.accountId}/user_contracts`,
    { params: opts?.queryParams }
  )
  return response.data
}
